import { useCallback } from 'react';

import type { ChangeEvent } from 'react';
import type { WidgetProps } from '@rjsf/utils';

import { Input } from '@/ui/Input';

import { Wrapper } from '../shared';

const Widget = <T, S, F>({
	disabled,
	formContext,
	id,
	name,
	onBlur,
	onChange,
	onFocus,
	placeholder,
	readonly,
	value,
}: WidgetProps<T, S, F>) => {
	const { readonlyAsDisabled = true } = formContext as F & { readonlyAsDisabled: boolean };

	const handleTextChange = useCallback(({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
		onChange(currentTarget.value);
	}, []);

	const handleBlur = useCallback(({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
		onBlur(id, currentTarget.value);
	}, []);

	const handleFocus = useCallback(({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
		onFocus(id, currentTarget.value);
	}, []);

	return (
		<Input
			disabled={disabled || (readonlyAsDisabled && readonly)}
			id={id}
			name={name}
			onBlur={!readonly ? handleBlur : undefined}
			onChange={!readonly ? handleTextChange : undefined}
			onFocus={!readonly ? handleFocus : undefined}
			placeholder={placeholder}
			type="url"
			value={value}
		/>
	);
};

const URLWidget = (props) => {
	const { value, onChange } = props;

	return (
		<Wrapper value={value} onChange={onChange}>
			<Widget {...props} />
		</Wrapper>
	)
}

export { URLWidget };
